<template>
  <Confirm
    :value="value"
    v-on="$listeners"
    title="Delete computer"
    :confirmBtn="{ text: 'Yes, delete' }"
  >
    <p>
      This action will delete
      <span class="has-text-weight-bold">
        {{ name }}
      </span>
      and everything related to it.
    </p>
    <p>Including:</p>
    <ul>
      <li>
        Authentication keys - computer will not be able to connect to Deployify
      </li>
      <li>Packages</li>
      <li>Inventory</li>
      <li>System information</li>
    </ul>

    <p>Note that nothing will be changed on the actual computer.</p>
  </Confirm>
</template>

<script>
import computerHelpers from "@/utils/computer";

export default {
  components: { Confirm: () => import("@/components/main/Confirm.vue") },
  computed: {
    name() {
      return computerHelpers.getName(this.computer);
    }
  },
  props: ["computer", "value"]
};
</script>
